import { render, staticRenderFns } from "./Level2.vue?vue&type=template&id=22203b40&scoped=true"
import script from "./Level2.vue?vue&type=script&lang=js"
export * from "./Level2.vue?vue&type=script&lang=js"
import style0 from "./Level2.vue?vue&type=style&index=0&id=22203b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22203b40",
  null
  
)

export default component.exports